import { LOCATION_CHANGE } from 'connected-react-router';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import createReducer from 'shared/utils/createReducer';

import { LOGOUT } from 'modules/auth/actions/logout';
import { SUBMIT_EDIT_USER_FORM } from '../actions/editUser';

const defaultState = {
  submitRequestStatus: requestsStatuses.default,
};

export default createReducer(defaultState, {
  [SUBMIT_EDIT_USER_FORM.failure]: state => ({
    ...state,
    submitRequestStatus: requestsStatuses.failure,
  }),
  [SUBMIT_EDIT_USER_FORM.pending]: state => ({
    ...state,
    submitRequestStatus: requestsStatuses.pending,
  }),
  [SUBMIT_EDIT_USER_FORM.success]: state => ({
    ...state,
    submitRequestStatus: requestsStatuses.success,
  }),

  [LOCATION_CHANGE]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
